import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { isLogged as authIsLogged, getUser, clearAuth } from "../utils/auth";
import PERMISSIONS, { hasUmatPermission } from "../utils/wkCommon";
import {hasUmatPermissionAsync} from "../utils/permissionsAsync";
import { isZh } from "../utils/language";
import FocusedEventsPanel from "../components/FocusedEventsPanel";
import { SongIcon } from "../components/_icons"

// ICONS: {hostname}/iconspreview.html

const providersNames = [
  'google',
/*
  'discord',
  'facebook',
  'github',
  'instagram',
  'linkedin',
  'reddit',
  'twitch',
  'twitter',
  'vk',
  'auth0',
*/
];

const Home = (props) => {
  const [isLogged, setIsLogged] = useState(authIsLogged());
  const [username, setUsername] = useState(getUser()?.username || '');
  const authUser = getUser();
  // new permission states
  const [permsReady, setPermsReady] = useState(false);
  
  const [canViewUmatData, setCanViewUmatData] = useState(false);
  const [canWriteUmatPermission, setCanWriteUmatPermission] = useState(false);
  const [canReadUmatPermission, setCanReadUmatPermission] = useState(false);
  const [canReadQiuDaoRen, setCanReadQiuDaoRen] = useState(false);
  const [canEditUmatData, setCanEditUmatData] = useState(false);
  const [canReadMedia, setCanReadMedia] = useState(false);
  const [canReadPreReg, setCanReadPreReg] = useState(false);
  const [canReadEventParticipant, setCanReadEventParticipant] = useState(false);
  const [isSysAdmin, setIsSysAdmin] = useState(false);

  useEffect(() => {
    let mounted = true;
    async function loadPerms() {
      try {
        const email = authUser?.email;

        // wait for async check if not in cache
        const ok = await hasUmatPermissionAsync(email, PERMISSIONS.UMATDATA_FULL)
                  || await hasUmatPermissionAsync(email, PERMISSIONS.UMATDATA_BASIC);
        if (mounted) setCanViewUmatData(Boolean(ok));

        const w = await hasUmatPermissionAsync(email, PERMISSIONS.UMATPERMISSION_WRITE);
        if (mounted) setCanWriteUmatPermission(Boolean(w));

        const a = await hasUmatPermissionAsync(email, PERMISSIONS.QIUDAOREN_READ);
        if (mounted) setCanReadQiuDaoRen(Boolean(a));

        const b = await hasUmatPermissionAsync(email, PERMISSIONS.UMATDATA_EDIT);
        if (mounted) setCanEditUmatData(Boolean(b));

        const c = await hasUmatPermissionAsync(email, PERMISSIONS.UMATPERMISSION_READ);
        if (mounted) setCanReadUmatPermission(Boolean(c));

        const d = await hasUmatPermissionAsync(email, PERMISSIONS.MEDIAFILE_BASIC);
        if (mounted) setCanReadMedia(Boolean(d));

        const e = await hasUmatPermissionAsync(email, PERMISSIONS.AGENDA_PREREG_READ);
        if (mounted) setCanReadPreReg(Boolean(e));

        const f = await hasUmatPermissionAsync(email, PERMISSIONS.EVENTPARTICIPANT_READ);
        if (mounted) setCanReadEventParticipant(Boolean(f));

        const g = await hasUmatPermissionAsync(email, PERMISSIONS.CONFIGROLEPERMISSION_EDIT);
        if (mounted) setIsSysAdmin(Boolean(g));
      } catch (e) {
        console.warn("loadPerms failed", e);

        if (
          e.message === "AUTH_INVALID" ||
          e.message === "HTTP_401" ||
          e.message === "HTTP_403"
        ) {
          clearAuth();
          window.location.href = "/";
          return;
        }

        if (e.message === "BACKEND_UNREACHABLE") {
          alert("Server tidak dapat dihubungi");
        }

        if (e.message === "NO_INTERNET") {
          alert("Tidak ada koneksi internet");
        }

      } finally {
        if (mounted) setPermsReady(true);
      }
    }

    if (isLogged) loadPerms();
    else setPermsReady(true); // no perms needed for anonymous

    return () => { mounted = false; };
  }, [isLogged, authUser]);

  const logout = (e) => {
    e.preventDefault();
    clearAuth();
    setIsLogged(false);
    setUsername('');
  };

  let text;

  if (isLogged) {
    text = isZh() ? `您好，${authUser?.umat.chineseName || authUser?.umat.fullName}!` : `Halo ${authUser?.umat.chineseName || authUser?.umat.fullName}!`;
  } else {
    text = ( isZh() ? "請先登入以開始使用" : "Silakan login untuk memulai akses data.");
  }

  // Render: use markup that matches MasterLayout's centered content while preserving original features.
  return (
    <div style={{ width: '100%' }}>
      {/* Top text and original buttons */}
      <div style={{ textAlign: 'center', padding: '6px 6px' }}>
        <p style={{ display:'none', fontSize: 18, color: '#1f2937' }}>{text}</p>
      </div>

      <div className="home-main">

        <FocusedEventsPanel/>

        {/* If logged, show the dashboard cards (this doesn't remove original features) */}
        <section style={{ marginTop: 0 }}>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',            // <<< penting agar turun ke bawah
            justifyContent: 'center',    // rata tengah
            gap: 12,
            maxWidth: 420,
            margin: '0 auto'
          }}>

            { isLogged && (
              <Link to="/AgendaCalendar" style={{ textDecoration: 'none' }}>
                <div role="button" aria-label="Kalender Kegiatan" style={{ cursor: 'pointer', background: '#fff', border: '2px solid #e2e8f0', borderRadius: 8, width: 120, height: 120, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#08306b' }}>
                  <div style={{ width: 44, height: 44, border: '0px solid #173a8a', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8 }}>
                    <img src="https://unpkg.com/heroicons@2.0.16/24/solid/calendar.svg" alt="Kalender Kegiatan" />
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 17, textAlign: 'center' }}>{ isZh() ? "行事曆" : "Kalender Kegiatan"}</div>
                </div>
              </Link>
            )}

            { canViewUmatData && (
              <Link to="/UmatData" style={{ textDecoration: 'none' }}>
                <div role="button" aria-label="Data Umat" style={{ cursor: 'pointer', background: '#fff', border: '2px solid #e2e8f0', borderRadius: 8, width: 120, height: 120, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#08306b' }}>
                  <div style={{ width: 44, height: 44, border: '0px solid #173a8a', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8 }}>
                    <img src="https://unpkg.com/heroicons@2.0.16/24/solid/user.svg" alt="Data Umat" />
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 17, textAlign: 'center' }}>{ isZh() ? "基本資料" : "Data Umat"}</div>
                </div>
              </Link>
            )}

            { canViewUmatData && (
              <Link to="/UmatListNav" style={{ textDecoration: 'none' }}>
                <div role="button" aria-label="Grup dan Komunitas" style={{ cursor: 'pointer', background: '#fff', border: '2px solid #e2e8f0', borderRadius: 8, width: 120, height: 120, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#08306b' }}>
                  <div style={{ width: 44, height: 44, border: '0px solid #173a8a', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8 }}>
                    <img src="https://unpkg.com/heroicons@2.0.16/24/solid/users.svg" alt="Grup dan Komunitas" />
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 17, textAlign: 'center' }}>{ isZh() ? "團體與社群" : "Grup & Komunitas"}</div>
                </div>
              </Link>
            )}

            { isLogged && (
              <Link to="/files" style={{ textDecoration: 'none' }}>
                <div role="button" aria-label="禮恩檔案 Files" style={{ cursor: 'pointer', background: '#fff', border: '2px solid #e2e8f0', borderRadius: 8, width: 120, height: 120, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#08306b' }}>
                  <div style={{ width: 44, height: 44, border: '0px solid #173a8a', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8 }}>
                    <img src="https://unpkg.com/heroicons@2.0.16/24/outline/document.svg" alt="Files" />
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 17, textAlign: 'center' }}>{ isZh() ? "禮恩檔案" : "Files"}</div>
                </div>
              </Link>
            )}

            { canReadMedia && (
              <Link to="/songs" style={{ textDecoration: 'none' }}>
                <div role="button" aria-label="善歌 Lagu Suci" style={{ cursor: 'pointer', background: '#fff', border: '2px solid #e2e8f0', borderRadius: 8, width: 120, height: 120, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#08306b' }}>
                  <div style={{ width: 44, height: 44, border: '0px solid #173a8a', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8 }}>
                    <SongIcon />
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 17, textAlign: 'center' }}>{ isZh() ? "善歌" : "Lagu Suci"}</div>
                </div>
              </Link>
            )}

            { isLogged && (
              <Link to="/g/nav" style={{ textDecoration: 'none' }}>
                <div role="button" aria-label={ isZh() ? "小點心" : "Soul Cookies"} style={{ cursor: 'pointer', background: '#fff', border: '2px solid #e2e8f0', borderRadius: 8, width: 120, height: 120, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#08306b' }}>
                  <div style={{ width: 44, height: 44, border: '0px solid #173a8a', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8 }}>
                    <img src="/games/intermezzo.svg" alt={ isZh() ? "小點心" : "Soul Cookies"} style={{ width: 44, height: 44 }} />
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 17, textAlign: 'center' }}>{ isZh() ? "小點心" : "Soul Cookies"}</div>
                </div>
              </Link>
            )}

            { isSysAdmin && canReadPreReg && (
              <Link to="/prereglist" style={{ textDecoration: 'none' }}>
                <div role="button" aria-label={ isZh() ? "報名表" : "Pra-Registrasi"} style={{ cursor: 'pointer', background: '#fff', border: '2px solid #e2e8f0', borderRadius: 8, width: 120, height: 120, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#08306b' }}>
                  <div style={{ width: 44, height: 44, border: '0px solid #173a8a', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8 }}>
                    <img src="/icons/prereg.svg" alt={ isZh() ? "報名表" : "Pra-Registrasi"} style={{ width: 44, height: 44 }} />
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 17, textAlign: 'center' }}>{ isZh() ? "報名表" : "Pra-Registrasi"}</div>
                </div>
              </Link>
            )}

            { canReadEventParticipant && (
              <Link to="/PresensiReport" style={{ textDecoration: 'none' }}>
                <div role="button" aria-label={ isZh() ? "簽到表" : "Daftar Kehadiran"} style={{ cursor: 'pointer', background: '#fff', border: '2px solid #e2e8f0', borderRadius: 8, width: 120, height: 120, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#08306b' }}>
                  <div style={{ width: 44, height: 44, border: '0px solid #173a8a', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8 }}>
                    <img src="/icons/presensi.svg" alt={ isZh() ? "簽到表" : "Daftar Kehadiran"} style={{ width: 44, height: 44 }} />
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 17, textAlign: 'center' }}>{ isZh() ? "簽到表" : "Daftar Kehadiran"}</div>
                </div>
              </Link>
            )}

            { canEditUmatData && (
              <Link to="/UmatDataUpdate" style={{ textDecoration: 'none' }}>
                <div role="button" aria-label="Update Data Umat" style={{ cursor: 'pointer', background: '#fff', border: '2px solid #e2e8f0', borderRadius: 8, width: 120, height: 120, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#08306b' }}>
                  <div style={{ width: 44, height: 44, border: '0px solid #173a8a', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8 }}>
                    <img src="https://lefyr2.com/Data_List_d8ed8b5b62.svg" style={{ width: 44, height: 44 }} alt="Update Data Umat" />
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 17, textAlign: 'center' }}>{ isZh() ? "更新道親資料" : "Update Data Umat"}</div>
                </div>
              </Link>
            )}

            {/* Profile Pic Update */}
            { canEditUmatData && (
              <Link to="/ProfilePicUpdate" style={{ textDecoration: 'none' }}>
                <div role="button" aria-label={ isZh() ? "更新道親頭像" : "Update Foto Profil"} style={{ cursor: 'pointer', background: '#fff', border: '2px solid #e2e8f0', borderRadius: 8, width: 120, height: 120, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#08306b' }}>
                  <div style={{ width: 44, height: 44, border: '0px solid #173a8a', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8 }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={1.5}
                      style={{ width: 44, height: 44 }}
                      aria-label={isZh() ? "更新道親頭像" : "Update Foto Profil"}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                      />
                    </svg>
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 17, textAlign: 'center' }}>{ isZh() ? "更新道親頭像" : "Update Foto Profil"}</div>
                </div>
              </Link>
            )}

            { canReadQiuDaoRen && (
              <Link to="/QiuDaoBook" style={{ textDecoration: 'none' }}>
                <div role="button" aria-label="Buku QiuDao" style={{ cursor: 'pointer', background: '#fff', border: '2px solid #e2e8f0', borderRadius: 8, width: 120, height: 120, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#08306b' }}>
                  <div style={{ width: 44, height: 44, border: '0px solid #173a8a', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8 }}>
                    <img src="https://unpkg.com/heroicons@2.0.16/24/outline/book-open.svg" alt="Buku QiuDao" />
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 17, textAlign: 'center' }}>{ isZh() ? "求道簿" : "Buku Qiu Dao"}</div>
                </div>
              </Link>
            )}
            
            {/* Role Permission Check */}
            { canReadUmatPermission && (
              <Link to="/RolePermissionCheck" style={{ textDecoration: 'none' }}>
                <div role="button" aria-label={ isZh() ? "權限角色檢查" : "Cek Role & Akses"} style={{ cursor: 'pointer', background: '#fff', border: '2px solid #e2e8f0', borderRadius: 8, width: 120, height: 120, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#08306b' }}>
                  <div style={{ width: 44, height: 44, border: '0px solid #173a8a', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8 }}>
                    <img src="https://unpkg.com/heroicons@2.0.16/24/outline/finger-print.svg" style={{ width: 44, height: 44 }} alt={ isZh() ? "權限角色檢查" : "Cek Role & Akses"} />
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 17, textAlign: 'center' }}>{ isZh() ? "權限角色檢查" : "Cek Role dan Akses"}</div>
                </div>
              </Link>
            )}

            {/* Users, Role & Permission */}
            { canReadUmatPermission && (
              <Link to="/AdminUsersPage" style={{ textDecoration: 'none' }}>
                <div role="button" aria-label={ isZh() ? "使用者與權限管理" : "User, Role dan Akses"} style={{ cursor: 'pointer', background: '#fff', border: '2px solid #e2e8f0', borderRadius: 8, width: 120, height: 120, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#08306b' }}>
                  <div style={{ width: 44, height: 44, border: '0px solid #173a8a', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8 }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={1.5}
                      style={{ width: 44, height: 44 }}
                      aria-label={isZh() ? "使用者與權限管理" : "User, Role dan Akses"}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0 1 18 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3 1.5 1.5 3-3.75"
                      />
                    </svg>
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 17, textAlign: 'center' }}>{ isZh() ? "使用者與權限管理" : "User, Role dan Akses"}</div>
                </div>
              </Link>
            )}


            { isLogged && (
              <Link to="/GanZhiCalendar" style={{ textDecoration: 'none' }}>
                <div role="button" aria-label={ isZh() ? "干支曆與節氣" : "Kalender GanZhi"} style={{ cursor: 'pointer', background: '#fff', border: '2px solid #e2e8f0', borderRadius: 8, width: 120, height: 120, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#08306b' }}>
                  <div style={{ width: 44, height: 44, border: '0px solid #173a8a', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8 }}>
                    <img src="/icons/GanZhiCalendar.png" style={{ width: 44, height: 44 }} alt={ isZh() ? "干支曆與節氣" : "Kalender GanZhi"} />
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 17, textAlign: 'center' }}>{ isZh() ? "干支曆與節氣" : "Kalender GanZhi"}</div>
                </div>
              </Link>
            )}
          </div>

          {/* Keep a placeholder area where the rest of dashboard content can go */}
          <div style={{ marginTop: 22, maxWidth: 720, marginLeft: 'auto', marginRight: 'auto', display: 'none' }}>
            <div style={{ background: '#ffffff', border: '1px solid #e6eef8', padding: 14, borderRadius: 8 }}>
              <h3 style={{ marginTop: 0 }}>Dashboard</h3>
              <p style={{ marginBottom: 0, color: '#4a5568' }}>
                This area is where your authenticated content will appear (tables, lists, etc.). The existing login/logout and connect buttons remain unchanged.
              </p>
            </div>
          </div>
        </section>
      </div>

      {/* Disclaimer (kept, same as before but styled) */}
      <div style={{ marginTop: 20, width: '100%', maxWidth: 960, marginLeft: 'auto', marginRight: 'auto' }}>
        <div style={{
          background: '#fdecea',
          border: '2px solid #e7a6a6',
          color: '#9a1e1e',
          padding: 16,
          borderRadius: 12,
          display: 'flex',
          gap: 10,
          alignItems: 'flex-start',
          fontSize: 16
        }}>
          <div style={{ fontSize:28, marginRight:12 }}>⚠️</div>
          <div>
            { isZh() ? 
              "本應用程式內之資料僅供內部使用，未經許可，不得於課程／活動行政用途以外之情況下對外散佈。" : 
              "Data dalam aplikasi ini hanya digunakan untuk keperluan internal, dilarang menyebarkan tanpa ijin di luar keperluan administrasi kelas/kegiatan."
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;